<template>
  <div :class="appendCssClass">
    <v-select :multiple="multiple"
              :filterable="false"
              :options="options"
              @open="onOpen"
              @close="onClose"
              @search="onSearch"
              @change="onChange"
              @input="emitSelection"
              v-model="selectedValues"
              :name="fieldName">
      <template slot="no-options">
        Geen resultaten
      </template>
      <template slot="option" slot-scope="option">
        <div class="d-center" :key="option.key">
          {{ option.label }}
        </div>
      </template>
      <template slot="selected-option" slot-scope="option">
        <div class="selected d-center" :key="option.key">
          {{ option.label }}
        </div>
      </template>
      <template slot="list-footer">
        <li ref="load" class="v-select-loader" v-show="hasNextPage">
          Laden...
        </li>
      </template>
    </v-select>
    <input type="hidden" :name="fieldName" v-for="selected in selectedValues" :value="selected.key"/>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import officeApi from '~/api/office';

export default {
  name: "SelectOfficeComponent",
  props: {
    fieldName: {
      type: String,
      default: ''
    },
    selectedOfficeIds: {
      type: Array,
      default: () => ([])
    },
    appendCssClass: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      page: 1,
      pages: 0,
      perPage: 15,
      data: [],
      searchResults: [],
      selectedValues: [],
      fetching: false
    };
  },
  computed: {
    hasNextPage() {
      return this.pages > this.page;
    },
    options() {
      return this.searchResults.length > 0 ? this.searchResults : this.data;
    }
  },
  methods: {
    async bindObserver() {
      await this.$nextTick();
      this.observer.observe(this.$refs.load)
    },
    onSearch(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.search(loading, search, this);
      } else {
        this.searchResults = [];
      }
    },
    onOpen() {
      if (this.hasNextPage) {
        this.bindObserver();
      }
    },
    onClose() {
      this.observer.disconnect();
    },
    onChange() {
      this.$emit('change', this.selectedValues);
    },
    search: debounce((loading, search, vm) => {
      officeApi.searchByName(search)
          .then(response => {
            vm.searchResults = response.data.map(office => ({
              office: office,
              key: office.id,
              label: office.name,
            })).filter(result => !vm.selectedValues.find(selected => selected.key === result.key))
            // FIXME? TypeError: vm.selectedValues.find is not a function (vm.selectedValues is an Observer object)
            // if (vm.selectedValues !== null && Object.keys(vm.selectedValues).length !== 0) {
            //   vm.searchResults = vm.searchResults.filter(result => result.key !== vm.selectedValues.key) // note: !working for multiple select
            // }
          })
          .catch(error => {
            vm.searchResults = [];
          })
          .finally(() => {
            loading(false);
          })
    }, 350),
    async infiniteScroll([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.parentElement;
        const scrollTop = ul.scrollTop;
        this.page++;

        await officeApi.paginateOffices(this.page, this.perPage)
            .then(async response => {
              const data = response.data.map(office => ({
                office: office,
                key: office.id,
                label: office.name,
              }));

              this.data = this.data.concat(data);

              this.pages = response.meta.pagination.total_pages;

              await this.$nextTick();
              ul.scrollTop = scrollTop;
            })
            .catch(error => {
              this.data = [];
            })
            .finally(() => {
              this.fetching = false;
            })
      }
    },
    emitSelection() {
      this.$emit('office-selection', this.selectedValues);
    },
  },
  created() {
    officeApi.paginateOffices(this.page, this.perPage)
        .then(response => {
          this.data = response.data.map(office => ({
            office: office,
            key: office.id,
            label: office.name,
          }));

          this.pages = response.meta.pagination.total_pages;
          if (this.hasNextPage) {
            this.bindObserver();
          }
        })
        .catch(error => {
          this.data = [];
        })
        .finally(() => {
          this.fetching = false;
        });

    if (this.selectedOfficeIds.length > 0) {
      officeApi.getByIds(this.selectedOfficeIds)
          .then(response => {
            this.selectedValues = response.data.map(office => ({
              office: office,
              key: office.id,
              label: office.name,
            }))
          })
          .catch(error => {
            this.selectedValues = [];
          })
          .finally(() => {
            this.fetching = false;
          });
    }

    this.observer = new IntersectionObserver(this.infiniteScroll);
  },
}
</script>

<style scoped>
.ant-select-selection__choice__remove {
  margin-top: .5rem;
}

.d-center {
  display: flex;
  align-items: center;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 20px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}

.v-select-loader {
  text-align: center;
  color: #bbbbbb;
}

</style>
